import React from 'react';
import ReactView from "shared/react_view";
import AccountSyncAlert from './../components/AccountSyncAlert';
/*
  TODO: This file should be removed when the facebook connect app is converted to Webpacker
 */

export default class AccountSyncAlertView extends ReactView {
  constructor(syncErrorMessage) {
    super(
      <AccountSyncAlert
        message={syncErrorMessage}
      />
    );
  }
}
